module.exports = __webpack_public_path__ + "static/media/x-twitter.d0b958e8.svg";